// 初始化 节点栏 元素列表
import { ActionType } from "./enums";
import { getActionTypeTheme } from "./transform";

// 基础样式
const BaseStyle = {
    rect: {
        width: '100px',
        height: '50px',
        lineHeight: '36px',
        textAlign: 'center',
        border: '2px solid #5b8ffa',
        backgroundColor: '#9ec9ff',
        borderRadius: '4px',
        color: '#7D7671'
    },
    ellipse: {
        width: '100px',
        height: '50px',
        lineHeight: '50px',
        textAlign: 'center',
        border: '2px solid #5b8ffa',
        backgroundColor: '#9ec9ff',
        borderRadius: '50px / 25px',
        color: '#7D7671'
    },
    // diamond 菱形
    diamond: {
        width: '52px',
        height: '52px',
        lineHeight: '36px',
        textAlign: 'center',
        border: '2px solid #5b8ffa',
        backgroundColor: '#9ec9ff',
        borderRadius: '4px',
        color: '#7D7671',
        transform: 'rotateZ(45deg)'
        // transform: 'rotate(45deg)',
        // transform: 'rotate(-45deg)'
    },
    // 数据加工作业
    datajob: {
        width: '200px',
        height: '48px',
        lineHeight: '36px',
        textAlign: 'center',
        border: '2px solid #5F95FF',
        borderLeft: '8px solid #5F95FF',
        backgroundColor: '#9ec9ff',
        borderRadius: '4px',
        color: '#7D7671',
        position: 'relative',
    },
    // 数据采集作业
    datajob: {
        width: '200px',
        height: '48px',
        lineHeight: '36px',
        textAlign: 'center',
        border: '2px solid #5F95FF',
        borderLeft: '8px solid #5F95FF',
        backgroundColor: '#9ec9ff',
        borderRadius: '4px',
        color: '#7D7671',
        position: 'relative',
    },
}

function getStyles(type) {
    const { TRIGGER, CONDITION, ACTION, DATA_JOB, DATA_COLLECT } = ActionType
    let base;
    const targetTheme = getActionTypeTheme(type)
    switch (type) {
        case TRIGGER:
            base = BaseStyle.ellipse
            break;
        case CONDITION:
            base = BaseStyle.diamond
            break;
        case ACTION:
            base = BaseStyle.rect
            break;
        case DATA_JOB:
            base = BaseStyle.datajob
            break;
        case DATA_COLLECT:
            base = BaseStyle.datajob
            break;
        default:
            break;
    }
    return {
        ...base,
        backgroundColor: targetTheme.background,
        borderColor: targetTheme.border
    }
}

export const nodes = [
    {
        label: '触发器',
        actionType: ActionType.TRIGGER,
        styles: getStyles(ActionType.TRIGGER),
        shape: 'ellipse'
    },
    {
        label: '条件',
        actionType: ActionType.CONDITION,
        styles: getStyles(ActionType.CONDITION),
        shape: 'diamond'
    },
    {
        label: '动作',
        actionType: ActionType.ACTION,
        styles: getStyles(ActionType.ACTION),
        shape: 'rect'
    },
]

export const datajobNodes = [
    {
        label: 'FlinkSQL作业',
        actionType: ActionType.DATA_JOB,
        styles: getStyles(ActionType.DATA_JOB),
        shape: 'rect',
        jobType: 'FlinkSQL'
    },
    {
        label: 'Doris作业',
        actionType: ActionType.DATA_JOB,
        styles: getStyles(ActionType.DATA_JOB),
        shape: 'rect',
        jobType: 'Doris'
    },
    {
        label: 'Python作业',
        actionType: ActionType.DATA_JOB,
        styles: getStyles(ActionType.DATA_JOB),
        shape: 'rect',
        jobType: 'Python'
    },
    {
        label: '脚本作业',
        actionType: ActionType.DATA_JOB,
        styles: getStyles(ActionType.DATA_JOB),
        shape: 'rect',
        jobType: 'Shell'
    }
]

export const datacollectNodes = [
    {
        label: '数据采集',
        actionType: ActionType.DATA_COLLECT,
        styles: getStyles(ActionType.DATA_COLLECT),
        shape: 'rect',
        jobCode: '',
        jobType: 'Collect'
    },
]